// extracted by css-extract-rspack-plugin
export default {"boxBackground":"footer-fragment__Box_boxBackground__0TqfK"};